<!-- 星号 -->
<template>
    <b class="require_star" title="必填项"></b>
</template>

<script>

export default {
  name: "RequireStar",
  props: {
    msg: String
  },
  data() {
    return {
    };
  },
  methods: {
    init() {
      var _this = this;
    },
    DoChange(item) {

    }
  },
  mounted: function() {
    this.init();
  },
  beforeMount:function(){
  },
  watch: {
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
